const types = {
    SET_GET_CASHBACK_LIST: '[CASHBACK] SET GET CASHBACK LIST',
}

export {
    types
}